import Vue from "vue";
import GloballySelected from "../store/modules/selected";
import ObjectModel from "../../../common/models/objectModel";
import ObjectModelProperty from "../../../common/models/objectModelProperties/objectModelProperty";
import ObjectModelRelation from "../../../common/models/objectModelRelations/objectModelRelation";
import ObjectModelAction from "../../../common/models/objectModelActions/objectModelAction";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import PropertySection from "~/models/objectModels/propertySection";
import Organization from "~/models/organization";

export default Vue.extend({
  computed: {
    selectedObjectModel(): ObjectModel {
      return GloballySelected.objectModel.get();
    },
    selectedObjectModelProperty(): ObjectModelProperty {
      return GloballySelected.objectModelProperty.get();
    },
    selectedPropertySection(): PropertySection {
      return GloballySelected.propertySection.get();
    },
    selectedObjectModelRelation(): ObjectModelRelation {
      return GloballySelected.objectModelRelation.get();
    },
    selectedObjectModelAction(): ObjectModelAction {
      return GloballySelected.objectModelAction.get();
    },
    selectedObjectModelTrigger(): ObjectModelTrigger {
      return GloballySelected.objectModelTrigger.get();
    },
    selectedOrganization(): Organization {
      return GloballySelected.organization.get();
    },
  },
});